'use client'

import { BuilderBlocks } from '@builder.io/react'

import { Container } from '@src/components/Container/Container'
import { type RailProps } from '@src/components/Rail/Rail.props'
import { RailCarousel } from '@src/components/Rail/RailCarousel/RailCarousel'
import { RailGrid } from '@src/components/Rail/RailGrid'
import { RailItemContextProvider } from '@src/components/Rail/RailItemContext'
import { useBreakpoints } from '@src/utils/breakpoints.util'
import { getBuilderPreviewMode } from '@src/utils/builder.util'
import { cn } from '@src/utils/tailwind'

export const Rail = (props: RailProps) => {
  const {
    blocksTop,
    builderBlock,
    columnsDesktop,
    columnsMobile,
    imageStyle,
    items,
    previewMode,
    slug,
    stackOnDesktop,
    stackOnMobile,
  } = props
  const { edit } = getBuilderPreviewMode()
  const breakpoints = useBreakpoints()
  const isMobile = breakpoints.isMobile || breakpoints.isTablet

  const isPreviewing = edit && previewMode
  const isCarouselVisible = (isMobile && !stackOnMobile) || (!isMobile && !stackOnDesktop)
  const showCarousel = !isPreviewing && isCarouselVisible

  const renderItemContainer = () => {
    return showCarousel ? (
      <RailCarousel
        items={items}
        columnsDesktop={columnsDesktop}
        columnsMobile={columnsMobile}
        isPreviewing={isPreviewing}
        builderBlock={builderBlock}
        imageStyle={imageStyle}
        slug={slug}
      />
    ) : (
      <RailGrid
        items={items}
        columnsDesktop={columnsDesktop}
        columnsMobile={columnsMobile}
        isPreviewing={isPreviewing}
        builderBlock={builderBlock}
        imageStyle={imageStyle}
        slug={slug}
      />
    )
  }

  return (
    <div className="flex flex-col">
      <Container
        className={cn({
          'mb-8': isPreviewing && !showCarousel,
        })}
      >
        <RailItemContextProvider slug={slug} position={0}>
          {blocksTop?.map(({ blocks }, index) => (
            <BuilderBlocks
              key={index}
              parentElementId={builderBlock?.id}
              blocks={blocks}
              dataPath={`component.options.blocksTop.${index}.blocks`}
            />
          ))}
        </RailItemContextProvider>
      </Container>
      {renderItemContainer()}
    </div>
  )
}
